import { localize2WithPath } from 'vscode/vscode/vs/nls';
import { Action2, registerAction2 } from 'vscode/vscode/vs/platform/actions/common/actions';
import { IKeybindingService } from 'vscode/vscode/vs/platform/keybinding/common/keybinding.service';
import { Categories } from 'vscode/vscode/vs/platform/action/common/actionCommonCategories';
import { ICommandService } from 'vscode/vscode/vs/platform/commands/common/commands.service';
import { showWindowLogActionId } from 'vscode/vscode/vs/workbench/services/log/common/logConstants';

const _moduleId = "vs/workbench/contrib/keybindings/browser/keybindings.contribution";
class ToggleKeybindingsLogAction extends Action2 {
    constructor() {
        super({
            id: 'workbench.action.toggleKeybindingsLog',
            title: ( localize2WithPath(_moduleId, 0, "Toggle Keyboard Shortcuts Troubleshooting")),
            category: Categories.Developer,
            f1: true
        });
    }
    run(accessor) {
        const logging = accessor.get(IKeybindingService).toggleLogging();
        if (logging) {
            const commandService = accessor.get(ICommandService);
            commandService.executeCommand(showWindowLogActionId);
        }
    }
}
registerAction2(ToggleKeybindingsLogAction);
